import { AlertCircle, Check, Loader2 } from "lucide-react";
import type { EtatSauvegarde } from "./use-sauvegarde-differee";

/**
 * État de l'autosave, posé près de l'action principale. `inactif` n'est pas
 * muet : dire d'emblée que tout s'enregistre seul rassure celui qui devra
 * s'interrompre en cours de route.
 */
export function IndicateurSauvegarde({
  etat,
  onReessayer,
}: {
  etat: EtatSauvegarde;
  onReessayer: () => void;
}) {
  return (
    <p className="inline-flex min-h-8 items-center gap-1.5 text-sm text-muted-foreground">
      {/* Seul l'échec est annoncé : « Enregistrement… / Enregistré » à chaque
          placement couvrirait l'annonce du placement lui-même. */}
      <span aria-live="polite" className="sr-only">
        {etat === "erreur" ? "Dernière modification non enregistrée." : ""}
      </span>
      {etat === "inactif" && "Vos réponses sont enregistrées automatiquement."}
      {etat === "en-cours" && (
        <>
          <Loader2 className="size-4 motion-safe:animate-spin" aria-hidden />
          Enregistrement…
        </>
      )}
      {etat === "enregistre" && (
        <>
          <Check className="size-4 text-charte-accent-light" aria-hidden />
          Enregistré
        </>
      )}
      {etat === "erreur" && (
        <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 text-destructive">
          <AlertCircle className="size-4" aria-hidden />
          Dernière modification non enregistrée.
          <button
            type="button"
            onClick={onReessayer}
            className="rounded-sm font-medium underline underline-offset-4 outline-none hover:no-underline focus-visible:ring-2 focus-visible:ring-destructive focus-visible:ring-offset-2"
          >
            Réessayer
          </button>
        </span>
      )}
    </p>
  );
}
